/* unplugin-vue-components disabled */import script from "./LoadingIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingIcon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__